import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate} from '@angular/router';
import {Observable} from 'rxjs';

export interface MxFormDeactivation {
    closeConfirmation: () => Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateFormGuard<T extends MxFormDeactivation> implements CanDeactivate<T> {

    canDeactivate(component: T,
                  currentRoute: ActivatedRouteSnapshot,
                  currentState: RouterStateSnapshot,
                  nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return component ? component.closeConfirmation ? component.closeConfirmation() : true : true;
    }
}
